<template>
    <div class="wrap-withdraw">
        <div class="main-content">
            <div class="wrap-content">
                <div class="title-page">Withdrawal</div>
                <div class="content">
                    <table>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Owner</th>
                                <th>Total Item</th>
                                <th>Total Weight (gr)</th>
                                <th>Pick Up Time</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoadingData">
                            <tr>
                                <td colspan="7">
                                    <b-spinner></b-spinner>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(withdrawal, i) in getWithdrawData" :key="i">
                                <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                                <td>{{ withdrawal.owner }}</td>
                                <td>{{ withdrawal.total_item }}</td>
                                <td>{{ withdrawal.total_weight }}</td>
                                <td>{{ withdrawal.withdrawal_detail.pickup_time | formatDate }}</td>
                                <td>
                                    <span v-show="withdrawal.status == '001'" class="status-withdrawal request">Processing</span>
                                    <span v-show="withdrawal.status == '002'" class="status-withdrawal kbi">Clearing Approve</span>
                                    <span v-show="withdrawal.status == '003'" class="status-withdrawal abx">KMI Approve</span>
                                    <span v-show="withdrawal.status == '004'" class="status-withdrawal handover">Client add detail withdrawal</span>
                                    <span v-show="withdrawal.status == '005'" class="status-withdrawal operator">Operator Confirmation</span>
                                    <span v-show="withdrawal.status == '006'" class="status-withdrawal kbi">Clearing Confirmation</span>
                                    <span v-show="withdrawal.status == '007'" class="status-withdrawal abx">KMI Confirmation</span>
                                    <span v-show="withdrawal.status == '008'" class="status-withdrawal handover">Client Withdrawal</span>
                                </td>
                                <td>
                                    <router-link :to="'/detail-withdrawal/' + withdrawal._id">
                                         <button type="button" class="btn btn-outline-info btn-sm">Detail</button>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="content d-flex justify-content-end mt-3">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="getTotalData"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="getTotalData > 10"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            typeWithdraw: "offexchange",
            currentPage: 1,
            perPage: 10,
            owner: "",
            startDate: "",
            endDate: "",
            status: "",
            serialNumber: "",
            activity: "withdrawal",
            hallmark: "",
            dateType: "",
            contract_id: "",
        };
    },
    mounted() {
        this.getData(this.currentPage, this.perPage, this.typeWithdraw, this.owner, this.startDate, this.endDate, this.status, this.serialNumber);
    },
    methods: {
        getData(currentPage, perPage, type, owner, startDate, endDate, status, serialNumber) {
            this.$store.dispatch("getWithdraw", {
                currentPage: currentPage,
                perPage: perPage,
                type: type,
                owner: owner,
                startDate: startDate,
                endDate: endDate,
                status: status,
                serialNumber: serialNumber,
            });
        },
        handlePageChange(value) {
            this.currentPage = value;
            this.getData(this.currentPage, this.perPage, this.typeWithdraw, this.owner, this.startDate, this.endDate, this.status, this.serialNumber);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
    computed: {
        getWithdrawData() {
            return this.$store.state.vaultModul.withdrawData;
        },
        getTotalData() {
            return this.$store.state.vaultModul.totalData;
        },
        isLoadingData() {
            return this.$store.state.vaultModul.isLoading;
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}
</style>
